// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8PetBzwF{display:flex;flex-direction:column;gap:max(1.13rem,min(1.25vw,1.5rem))}.e2fK1rPl{font-size:max(1.13rem,min(1.25vw,1.5rem));font-weight:600;font-weight:500}.YPaT9WT8{font-size:max(.75rem,min(.73vw,.88rem))}.Dqqi6BrK{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:max(.75rem,min(.83vw,1rem));gap:max(.75rem,min(.83vw,1rem))}@media(max-width:1023.98px){.Dqqi6BrK{display:flex;flex-direction:column}}.wRvbIaRo{width:100%}._8hi7BvBu{gap:max(.25rem,min(.83vw,1rem))}.Agc\\+Whro,._8hi7BvBu{align-items:center;display:flex}.Agc\\+Whro{font-size:2.5rem;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "_8PetBzwF",
	"title": "e2fK1rPl",
	"text": "YPaT9WT8",
	"control": "Dqqi6BrK",
	"controlBtn": "wRvbIaRo",
	"socials": "_8hi7BvBu",
	"social": "Agc+Whro"
};
module.exports = ___CSS_LOADER_EXPORT___;
